module.exports = function getFetchHeaders() {
	let headers = null;
	if (process.env.BASIC_AUTH_USERNAME && process.env.BASIC_AUTH_PASSWORD) {
		if (typeof btoa !== "undefined") {
			headers = {
				Authorization: `Basic ${btoa(
					`${process.env.BASIC_AUTH_USERNAME}:${process.env.BASIC_AUTH_PASSWORD}`
				)}`,
			};
		} else {
			headers = {
				Authorization: `Basic ${Buffer.from(
					`${process.env.BASIC_AUTH_USERNAME}:${process.env.BASIC_AUTH_PASSWORD}`,
					"utf-8"
				).toString("base64")}`,
			};
		}
	}

	return headers;
};
